import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      color: palette.text.white,
      userSelect: 'none',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
      maxWidth: 'max-content',
      marginLeft: 'auto',
      marginRight: 'auto',
      '@media (max-width: 768px)': {
        height: 'fill'
      }
    },
    formContainer: {
      maxWidth: '450px',
      width: '100%'
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      textAlign: 'start'
    },
    buttons: {
      display: 'flex',
      justifyContent: 'center',
      height: '39px'
    },
    help: {
      fontSize: '0.875rem',
      color: palette.common.red,
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      '@media (max-width: 768px)': {
        paddingLeft: '20px'
      }
    },
    title: {
      fontSize: '2.5rem',
      margin: '0',
      '@media (max-width: 768px)': {
        fontSize: '1.75rem'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
